module.exports = __webpack_public_path__ + "img/daan@2x.659d74a6.png";